// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BeliefsRouteImport } from './routes/beliefs'
import { Route as IndexRouteImport } from './routes/index'

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const BeliefsRoute = BeliefsRouteImport.update({
            id: '/beliefs',path: '/beliefs',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BeliefsRoute: BeliefsRoute,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)